import { Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { brl, fmtDateTime, imgUrl, PAY_LABELS } from "@/lib/api";

export function TicketPrint({ sale, onClose, onPrint }) {
  const { session } = useAuth();
  if (!sale) return null;
  const t = session.tenant;
  return (
    <Dialog open={!!sale} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm max-h-[92vh] overflow-y-auto" data-testid="ticket-print-modal">
        <DialogHeader><DialogTitle>Venda #{sale.number} · {sale.tickets.length} ticket(s)</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">Pago com {sale.payments.map((p) => PAY_LABELS[p.method]).join(" + ")} · Total <b>{brl(sale.total)}</b>{sale.change > 0 && <> · Troco <b data-testid="ticket-change">{brl(sale.change)}</b></>}</p>
        <div className="print-area space-y-3" data-testid="tickets-list">
          {sale.tickets.map((k) => (
            <div key={k.id} className="ticket-page rounded-lg border-2 border-dashed border-slate-400 bg-white p-4 text-center font-mono text-slate-900" data-testid={`ticket-${k.code}`}>
              {t.settings?.ticket_logo !== false && t.settings?.logo_url && <img src={imgUrl(t.settings.logo_url)} alt="Logo" className="mx-auto mb-1 h-10 object-contain" />}
              <p className="text-xs font-bold">{t.nome_fantasia}</p>
              <p className="my-2 text-lg font-extrabold uppercase leading-tight">{k.product_name}</p>
              <p className="text-[11px]">VALE 1 UNIDADE · {k.seq}/{k.of}</p>
              {sale.pickup_number && <p className="mt-1 text-sm font-bold" data-testid="ticket-pickup-number">SENHA {String(sale.pickup_number).padStart(3, "0")}</p>}
              <p className="mt-2 text-xl font-bold tracking-[0.3em]">{k.code}</p>
              <p className="mt-2 text-[10px]">Venda #{sale.number} · {fmtDateTime(k.created_at)} · {k.sold_by}</p>
              {sale.receipt_footer && <p className="mt-1 text-[10px] whitespace-pre-line">{sale.receipt_footer}</p>}
            </div>
          ))}
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onPrint || (() => window.print())} data-testid="tickets-print-btn"><Printer className="h-4 w-4 mr-2" />Imprimir tickets</Button>
          <Button onClick={onClose} data-testid="tickets-new-sale-btn">Nova venda</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
